import {
  FETCH_USER_BALANCES_SUCCEED,
  FETCH_USER_INFO_SUCCEED,
  UPDATE_USER_INFO_SUCCEED,
} from '../actions/user/action_types';
import { LOGIN_NORMAL_SUCCEED, LOGIN_QR_SUCCEED, LOGOUT } from '../actions/login/action_types';
import consts from '../../consts';
import utils from '../../common/utils';

const defaultParams = {
  userBalances: {},
  session: {},
  isAuthenticated: false,
  info: {},
  favorites: [],
};

export default (state = defaultParams, action) => {
  const myFavorites = [];
  switch (action.type) {
    // case FETCH_USER_BALANCES:
    // 	return {
    // 		...state,
    // 		isTableLoading: true,
    // 	};
    case FETCH_USER_BALANCES_SUCCEED:
      const userBalances = window._.reduce(action.params.data, (result, userBalance) => {
        result[userBalance.coin] = userBalance;
        result[userBalance.coin].key = userBalance.coin;
        return result;
      }, {});
      return {
        ...state,
        userBalances,
        // isTableLoading: false,
      };
    // case FETCH_USER_BALANCES_FAILED:
    // 	return {
    // 		...state,
    // 		isTableLoading: false,
    // 	}
    case LOGIN_QR_SUCCEED:
      window.$isAuthenticated = true;
      return {
        ...state,
        session: action.params.data,
        isAuthenticated: true,
      };
    case LOGIN_NORMAL_SUCCEED:
      window.$isAuthenticated = true;
      return {
        ...state,
        session: action.params.data,
        isAuthenticated: true,
      };
    case UPDATE_USER_INFO_SUCCEED:
      return {
        ...state,
        info: action.params.data,
      };
    case FETCH_USER_INFO_SUCCEED:
      return {
        ...state,
        info: action.params.data,
        heightNotification: 0,
      };
    case consts.WS_EVENT_UPDATE_COIN_ACCOUNT:
      return {
        ...state,
        userBalances: {
          ...state.userBalances,
          [action.data.coin]: action.data,
        },
      };
    // case consts.WS_EVENT_UPDATE_CURRENCY_ACCOUNT:
    //   return {
    //     ...state,
    //     userBalances: {
    //       ...state.userBalances,
    //       [action.data.coin]: action.data,
    //     },
    //   };
    // case consts.WS_EVENT_UPDATE_CURRENCY_ACCOUNT:
    //   return {
    //     ...state,
    //     userBalances: {
    //       ...state.userBalances,
    //       [action.data.coin]: action.data,
    //     },
    //   };
    // case consts.WS_EVENT_UPDATE_CURRENCY_ACCOUNT:
    //   return {
    //     ...state,
    //     userBalances: {
    //       ...state.userBalances,
    //       [action.data.coin]: action.data,
    //     },
    //   };
    case LOGOUT:
      window.$isAuthenticated = false;
      return {
        ...state,
        session: {},
        isAuthenticated: false,
        userBalances: {},
      };
    default:
      return {
        ...state,
      };
  }
};
